import * as React from 'react'
import { styles } from './styles.css'

export const GiftNote: React.FC = () => {
  return (
    <section className={styles.card}>
      <h3 className={styles.heading}>ギフト利用の方へ</h3>
      <ul className={styles.list}>
        <li className={styles.listItem}>明細書など値段のわかるものは同封されないのでご安心ください</li>
        <li className={styles.listItem}>あらかじめ受取人様に荷物が届く旨をお伝えいただけますと、受取拒否等のトラブルを防ぐことができます</li>
      </ul>
    </section>
  )
}
